import Button from './Button';

export type { IButtonProps } from './Button.types';
export default Button;
